import React from "react"
import styled from "styled-components"
import QuoteForm from "./QuoteForm"
import { truncateString } from "../../utils/helpers"
import { categoryAccentClass } from "../../utils/category-classes"
const QuoteWidget = styled.section`
    .border-top{
        border-top: 1px solid #ddd !important;
    }
    .quote-form{
        justify-content: center !important;
    }
`

export default ({ fromPage, censusPage, slug }) => {
    return (
        <QuoteWidget className="border-top">
            <span
                data-wa-depth={`${truncateString(
                    fromPage
                )}:CTA appears depthTracking`}
            />
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-md-9 col-lg-10 col-xl-9">
                        <h2 className="display-4">Looking for Health Insurance Plans?</h2>
                        <div className={`${slug ? categoryAccentClass[slug] : 'null'} mx-auto title-gap`}></div>
                        <p className="lead font-weight-light mb-5">Browse plans available in your area and compare quotes for free! Just fill in your zip code below and answer a few quick questions so that we can provide you with the most accurate pricing estimates. No hassle and no strings attached!</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-md-9 col-lg-10 col-xl-9">
                        <QuoteForm fromPage={fromPage} censusPage={censusPage} />
                    </div>
                </div>
            </div>
        </QuoteWidget>
    )
}
